import { Button, H, P } from '@feral/ui'
import { Outlet, useRouterState } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useSession } from '../lib/session.js'
import { framed, isFramedPath, openTop } from './framed.js'

/**
 * Inside the site's frame (app/framed.ts): Link your site membership runs as usual when signed in;
 * signed out, it offers to continue in the app; any other screen goes to the top window.
 */
export function FrameGuard() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const { me, loaded } = useSession()
  const allowed = isFramedPath(pathname)
  useEffect(() => {
    if (framed && !allowed) openTop(`${pathname}${window.location.search}`)
  }, [allowed, pathname])
  if (!framed) return <Outlet />
  if (!allowed || !loaded) return null
  if (me) return <Outlet />
  return (
    <div className="fm-screen" style={{ padding: 16, display: 'grid', gap: 12, alignContent: 'start' }}>
      <H>Link your site membership</H>
      <P>A paid membership on the site carries Feral Mode Plus. Sign in to the app to link yours.</P>
      <Button variant="primary" onClick={() => openTop('/plus/site')}>
        Continue in Feral Mode
      </Button>
    </div>
  )
}
